(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/route-play-spela.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/route-play-spela.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;

const _React = React,
  useContext = _React.useContext;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  matchPath = _ReactRouterDOM.matchPath;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const hasPlayer = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const getProductCompetitionId = svs.components.lbUtils.brandMapping.fn.getProductCompetitionId;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const DisabledCoupon = svs.components.marketplaceCompetition.disabledCoupon.DisabledCoupon;
const selectActiveCompetitionId = svs.components.marketplaceCompetition.services.selectors.competitionSelectors.selectActiveCompetitionId;
const useDrawSubscription = svs.components.sport.drawsRedux.hooks.useDrawSubscription;
const Play = svs.components.tipsen.routePlaySpela.Play;
const DetailViewRoutePlayHandler = svs.components.tipsen.detailViewRoutePlayHandler.DetailViewRoutePlayHandler;
const CouponAdditions = svs.components.tipsen.couponAdditions.CouponAdditions;
const COUPON_STANDARD = svs.components.tipsen.engine.constants.couponTypes.COUPON_STANDARD;
const CouponIdProvider = svs.components.tipsen.couponId.CouponIdProvider;
const CenterToScreen = svs.components.tipsen.centerToScreen.CenterToScreen;
const useCurrentCompetitions = svs.components.tipsen.hooks.useCurrentCompetitions;
const DrawContext = svs.components.tipsen.drawProvider.DrawContext;
const getCompetitionFactoryInstance = svs.components.tipsen.competition.competitionFactoryInstance.getCompetitionFactoryInstance;
const BetslipRegistry = svs.components.tipsen.betslipRegistry.BetslipRegistry;
const DrawSubscriberLight = _ref => {
  let productId = _ref.productId,
    drawNumber = _ref.drawNumber;
  useDrawSubscription(drawNumber, productId, {
    isLightUpdate: true
  });
  return null;
};
const RoutePlaySpela = _ref2 => {
  let match = _ref2.match;
  const _getCompetitionFactor = getCompetitionFactoryInstance().getCompetitionHooksForCms(),
    useCanPlayInCompetitionDraw = _getCompetitionFactor.useCanPlayInCompetitionDraw;
  const competitions = useCurrentCompetitions();
  const history = useHistory();
  const _useContext = useContext(DrawContext),
    productId = _useContext.productId,
    drawNumber = _useContext.drawNumber;
  const compId = getProductCompetitionId(productId);
  const activeCompetitionId = useSelector(selectActiveCompetitionId);
  const canPlayInCompetition = useCanPlayInCompetitionDraw({
    productId,
    drawNumber
  }, compId);
  const shouldShowDisabledCoupon = activeCompetitionId ? !canPlayInCompetition && hasPlayer : false;
  const hasCompetition = Boolean(competitions.find(comp => comp.id === compId));
  if (!hasCompetition && (matchPath(location.pathname, {
    path: "".concat(svs.core.data.baseUrl, "/").concat(TipsenModuleGameUrl.TIPS_SM),
    exact: true,
    strict: false
  }) || matchPath(location.pathname, {
    path: "".concat(svs.core.data.baseUrl, "/").concat(TipsenModuleGameUrl.TIPS_EM),
    exact: true,
    strict: false
  }))) {
    history.push({
      pathname: '/',
      search: location.search
    });
  }
  return React.createElement(CouponIdProvider, {
    type: COUPON_STANDARD
  }, React.createElement(DrawSubscriberLight, {
    drawNumber: drawNumber,
    productId: productId
  }), React.createElement(CenterToScreen, null, !shouldShowDisabledCoupon && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "grid-row tipsen-coupon-margin"
  }, React.createElement("div", {
    className: isSelfService ? 'col-md-6' : 'col-md-7'
  }, React.createElement(Play, {
    match: match
  })), React.createElement(DetailViewRoutePlayHandler, null)), React.createElement(CouponAdditions, null)), shouldShowDisabledCoupon && React.createElement(DisabledCoupon, {
    className: "tipsen-coupon-margin",
    drawNumber: drawNumber
  })), React.createElement(BetslipRegistry, null));
};
setGlobal('svs.components.tipsen.routePlaySpela.RoutePlaySpela', RoutePlaySpela);

 })(window);